import React, { useState } from "react";
import { Editor } from 'react-draft-wysiwyg';
import { convertFromHTML, EditorState, ContentState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { ISkillPath } from "../../model/SkillPath.model";
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';





const EditSkillPathAttributesComponent: React.FC<{
  skillPath: ISkillPath;
  updateSkillPathData(event: ISkillPath): void;
}> = (props: {
  skillPath: ISkillPath;
  updateSkillPathData(event: ISkillPath): void;
}) => {
    var skillPath = props.skillPath;
    console.log("form component w name ", skillPath.skillPathName);
    const [name, setName] = useState(skillPath.skillPathName);
    const [description, setDescription] = useState(skillPath.skillPathDescription);
    var spd = convertFromHTML((skillPath.skillPathDescription) ? skillPath.skillPathDescription : "");
    const spdCS = ContentState.createFromBlockArray(spd.contentBlocks, spd.entityMap);
    //const [editorState, setEditorState] = useState(ContentState.createFromBlockArray(spd.contentBlocks));
    const [isEditing, setIsEditing] = useState(false);

    const [editorState, setEditorState] = useState(EditorState.createWithContent(spdCS));// Toolbar configuration
    const toolbarOptions = {
      options: ['inline', 'list', 'link', 'history'],
      inline: {
        options: ['bold', 'italic', 'underline'],
      },
      list: {
        options: ['unordered', 'ordered'],
      },
      link: {
        options: ['link', 'unlink'],
      },
      history: {
        options: ['undo', 'redo']
      }
    };
    //editorState.set(spd)
    const onEditorStateChange = (newEditorState: EditorState) => {
      //debugger;
      setEditorState(newEditorState);
      const contentState = editorState.getCurrentContent();
      setDescription(stateToHTML(contentState));
    };
    //setName(skillPath.skillPathName);
    const HandleSubmit = (event: any) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const inputSN = formData.get("skillPathName");
      if (inputSN) skillPath.skillPathName = inputSN + "";
      if (description) skillPath.skillPathDescription = stateToHTML(editorState.getCurrentContent()) + "";

      props.updateSkillPathData(skillPath);
      setIsEditing(false);
    };
    const openEditing = () => {
      setIsEditing(true);
    }
    return (
      <>
        {isEditing && (
          <form onSubmit={HandleSubmit} className="p-1">
            <div className="aln-left m-b-1">
              <label htmlFor="skillPathName" >
                Edit Skill Path name:&nbsp;
                <input id="skillPathName" type="text" name="skillPathName" defaultValue={name} />
              </label>
            </div>
            <div className="aln-left m-t-1 m-b--50">
              <label>Description:</label>
            </div>
            <Editor editorState={editorState} onEditorStateChange={onEditorStateChange} toolbar={toolbarOptions} />
            <div className="m-t-1 dis-flex gap--50 dis-flex-jst-center">
              <button className="btn-secondary" type="submit">Update</button>
              {/*<button className="btn-med-gray" type="button" onClick={() => setIsEditing(false)}>Cancel</button>*/}
            </div>
            
          </form>
        )}
        {!isEditing && (
          <button className="btn-secondary" onClick={openEditing}>Edit</button>
        )}
      </>
    );
  };

export default EditSkillPathAttributesComponent;